module.exports = __webpack_public_path__ + "static/media/Receivership-Order-dated-June-6-2025-(3) - 2250310 Ontario Inc.9d5ce17d.pdf";